import {Price} from '../event/Price';

export default class PriceFormatter {
  static format(price: Price): string {
    const opts = {
      currency: price.currency,
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
      style: 'currency',
    };
    return Intl.NumberFormat('en-US', opts).format(price.amount);
  }
}
